import { render, staticRenderFns } from "./Canceled_agent.vue?vue&type=template&id=0622534a&scoped=true&lang=pug&"
import script from "./Canceled_agent.vue?vue&type=script&lang=js&"
export * from "./Canceled_agent.vue?vue&type=script&lang=js&"
import style0 from "./Canceled_agent.vue?vue&type=style&index=0&id=0622534a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622534a",
  null
  
)

export default component.exports